import { render, staticRenderFns } from "./OwnerContactSelect.vue?vue&type=template&id=4d8d2020&scoped=true"
import script from "./OwnerContactSelect.vue?vue&type=script&lang=js"
export * from "./OwnerContactSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d2020",
  null
  
)

export default component.exports